import moment from 'moment'

export const createOfferDatePreset = (minutes, now = Date.now()) => ({
  from: new Date(now - minutes * 60000).toISOString(),
  to: null
})

export const getOfferDateBounds = range => {
  if (!range || typeof range !== 'object') return null
  const readBound = value => {
    if (value == null || value === '') return null
    if (typeof value !== 'string' || !value) return NaN
    return moment(value, moment.ISO_8601, true).valueOf()
  }
  const from = readBound(range.from)
  const to = readBound(range.to)
  return (from !== null || to !== null) &&
    (from === null || Number.isFinite(from)) &&
    (to === null || Number.isFinite(to)) &&
    (from === null || to === null || to >= from)
    ? { from, to }
    : null
}

export const getOfferDateRangeFields = range => {
  const bounds = getOfferDateBounds(range)
  return {
    fromDate:
      bounds?.from != null ? moment(bounds.from).format('YYYY-MM-DD') : '',
    fromTime: bounds?.from != null ? moment(bounds.from).format('HH:mm') : '',
    toDate: bounds?.to != null ? moment(bounds.to).format('YYYY-MM-DD') : '',
    toTime: bounds?.to != null ? moment(bounds.to).format('HH:mm') : ''
  }
}

export const getOfferDateRangeFromFields = fields => {
  const names = ['fromDate', 'fromTime', 'toDate', 'toTime']
  if (names.every(name => !fields[name])) return 'all'
  const readBound = name => {
    const date = fields[`${name}Date`]
    const time = fields[`${name}Time`]
    if (!date && !time) return null
    if (!date || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time || '')) return undefined
    const input = `${date} ${time}`
    const format = 'YYYY-MM-DD HH:mm'
    const value = moment(input, format, true)
    // Include the whole final minute, so 23:59 reaches the end of the day.
    return value.isValid() && value.format(format) === input
      ? (name === 'to' ? value.endOf('minute') : value).toISOString()
      : undefined
  }
  const range = { from: readBound('from'), to: readBound('to') }
  if (range.from === undefined || range.to === undefined) return null
  return getOfferDateBounds(range) ? range : null
}

export const completeOfferDateRange = (fields, now = Date.now()) => {
  const names = ['fromDate', 'fromTime', 'toDate', 'toTime']
  if (names.every(name => !fields[name])) return { fields, range: 'all' }

  const today = moment(now).format('YYYY-MM-DD')
  const hasFrom = Boolean(fields.fromDate || fields.fromTime)
  const hasTo = Boolean(fields.toDate || fields.toTime)
  const fromDate = hasFrom ? fields.fromDate || today : ''
  const toDate = hasTo ? fields.toDate || today : ''
  const completedFields = {
    ...fields,
    fromDate,
    toDate,
    fromTime: hasFrom ? fields.fromTime || '00:00' : '',
    toTime: hasTo ? fields.toTime || '23:59' : ''
  }
  return {
    fields: completedFields,
    range: getOfferDateRangeFromFields(completedFields)
  }
}

export const getOfferDateRangeFilters = range => {
  const bounds = getOfferDateBounds(range)
  return {
    createdAtFrom: bounds?.from != null ? range.from : null,
    createdAtTo: bounds?.to != null ? range.to : null
  }
}

export const getOfferDateRangeFromFilters = filters => {
  const range = { from: filters.createdAtFrom, to: filters.createdAtTo }
  return getOfferDateBounds(range) ? range : 'all'
}

export const formatOfferDateRange = (range, intl) => {
  const bounds = getOfferDateBounds(range)
  if (!bounds) return null
  const from =
    bounds.from != null ? moment(bounds.from).format('DD.MM.YYYY HH:mm') : null
  const to =
    bounds.to != null ? moment(bounds.to).format('DD.MM.YYYY HH:mm') : null
  if (from && to) {
    return intl.formatMessage(
      { id: 'offersFilters.createdAtRangeSummary' },
      { from, to }
    )
  }
  const id = from
    ? 'offersFilters.createdAtFromSummary'
    : 'offersFilters.createdAtToSummary'
  return intl.formatMessage({ id }, { from, to })
}
